import { Button, Modal } from 'antd';
import { useInvoiceCFEFormContext } from '../../InvoiceCFEFormProvider';
import { useManagerCouponCancel } from '@/core/domain/coupon/managerCoupon/managerCoupon.hooks';
import { useTaxCouponCancel } from '@/core/domain/coupon/coupons/coupons.hooks';
import { TaxCouponStatus } from '@/core/domain/coupon/coupons/coupons.types';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const InvoiceCFECancel: React.FC = () => {
  const { taxCoupon } = useInvoiceCFEFormContext();

  const managerCouponCancel = useManagerCouponCancel();
  const taxCouponCancel = useTaxCouponCancel();

  async function cancelConfirm() {
    Modal.confirm({
      title: 'Cancelar cupom fiscal',
      content: 'Deseja realmente cancelar o cupom fiscal atual?',
      onOk: async () => {
        if (taxCoupon && taxCoupon.sefazReferenceCode) {
          try {
            await managerCouponCancel.mutateAsync({
              sefazReferenceCode: taxCoupon.sefazReferenceCode,
            });
            await taxCouponCancel.mutateAsync(taxCoupon.id);
          } catch {}
        }
      },
    });
  }

  return (
    <>
      <Button
        type="primary"
        danger
        onClick={cancelConfirm}
        disabled={
          !taxCoupon?.sefazReferenceCode ||
          taxCoupon.status === TaxCouponStatus.CANCELED ||
          !hasPermissions([Authorities.FISCAL_COUPON_CANCELLATION])
        }
      >
        Cancelar CF-e
      </Button>
    </>
  );
};

export default InvoiceCFECancel;
